"use client"
import React, { useState, useEffect } from 'react';

const CarouselComponent = ({ cardData }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const updateView = () => {
            setIsMobile(window.innerWidth < 768);
        };

        updateView();
        window.addEventListener('resize', updateView);
        return () => window.removeEventListener('resize', updateView);
    }, []);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % cardData.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? cardData.length - 1 : prevIndex - 1
        );
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    if (isMobile) {
        return (
            <div id="default-carousel" className="relative bg-white border border-[#D4DDD1] shadow-lg rounded-2xl w-full p-4" data-carousel="slide">
                {/* Carousel Wrapper */}
                <div className="relative h-auto overflow-hidden rounded-lg">
                    {cardData.map((card, index) => (
                        <div
                            key={index}
                            className={`duration-700 ease-in-out ${index === currentIndex ? 'block' : 'hidden'}`}
                            data-carousel-item
                        >
                            <div className="p-8">
                                <h3 className="text-2xl font-bold mb-4 text-[#2C6E63]">{card.title}</h3>
                                <p className="text-center mb-4">{card.description}</p>
                                <p className="font-bold underline mb-3">Causes principales :</p>
                                <ul className="list-disc pl-5 space-y-2 text-left">
                                    {card.causes.map((cause, idx) => (
                                        <li key={idx} className="text-base leading-relaxed ">{cause}</li>
                                    ))}
                                </ul>
                                <p className="font-bold underline mb-3 mt-3">Prise en charge naturopathique :</p>
                                <ul className="list-disc pl-5 space-y-2 text-left">
                                    {card.treatment.map((item, idx) => (
                                        <li key={idx} className="text-base leading-relaxed ">{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
                {/* Slider Indicators */}
                <div className="absolute z-30 flex -translate-x-1/2 -bottom-10 left-1/2 space-x-3 rtl:space-x-reverse">
                    {cardData.map((_, index) => (
                        <button
                            key={index}
                            type="button"
                            className={`w-4 h-4 rounded-full ${currentIndex === index ? 'bg-[#2C6E63]' : 'bg-gray-400'}`}
                            aria-current={currentIndex === index}
                            aria-label={`Slide ${index + 1}`}
                            onClick={() => goToSlide(index)}
                        ></button>
                    ))}
                </div>
                {/* Slider Controls */}
                <button
                    type="button"
                    className="absolute top-0 -left-3 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                    onClick={handlePrev}
                >
                    <span className="inline-flex items-center justify-center w-10 h-10">
                        <svg
                            className="w-6 h-6 text-[#2C6E63] rtl:rotate-180"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 6 10"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 1 1 5l4 4"
                            />
                        </svg>
                        <span className="sr-only">Previous</span>
                    </span>
                </button>
                <button
                    type="button"
                    className="absolute top-0 -right-3 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                    onClick={handleNext}
                >
                    <span className="inline-flex items-center justify-center w-10 h-10">
                        <svg
                            className="w-6 h-6 text-[#2C6E63] rtl:rotate-180"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 6 10"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="m1 9 4-4-4-4"
                            />
                        </svg>
                        <span className="sr-only">Next</span>
                    </span>
                </button>
            </div>
        );
    }

    return (
        <div className="hidden md:grid lg:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 p-4">
            {cardData.map((card, index) => (
                <div key={index} className="p-4 h-full">
                    <div className="p-8 h-full bg-white border border-[#D4DDD1] shadow-lg rounded-2xl">
                        <h2 className="text-center font-bold text-xl mb-4">{card.title}</h2>
                        <p className="text-center text-lg mb-4">{card.description}</p>
                        <p className="font-bold underline mb-5">Causes principales :</p>
                        <ul className="list-disc list-inside space-y-2">
                            {card.causes.map((cause, idx) => (
                                <li key={idx} className="text-gray-700 text-base">{cause}</li>
                            ))}
                        </ul>
                        <p className="font-bold underline mb-5 mt-5">Prise en charge naturopathique :</p>
                        <ul className="list-disc list-inside space-y-2">
                            {card.treatment.map((item, idx) => (
                                <li key={idx} className="text-gray-700 text-base">{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CarouselComponent;

